import { styled } from '@mui/material/styles';
import { Avatar, Link } from '@mui/material';
import { useState, useEffect } from 'react';
import { useFollowUserMutation, useUnfollowUserMutation } from '../../../../store/api/userApi';
import UserFollowBtn from '../../../../components/shared/Button/UserFollowBtn';
import ActionDialog from '../../../../components/shared/Dialog/ActionDialog';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { DEFAULT_AVATAR } from '../../../../utils/constant';
import {
  PopupNotification,
  toastUnfollow,
  toastFollow,
} from '../../../../components/shared/PopupNotification/PopupNotification';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const AuthorContainer = styled('div')({
  display: 'flex',
  padding: '8px 0 10px',
});

const AvatarBox = styled(Avatar)({
  width: '50px',
  height: '50px',
});

const AuthorName = styled('div')({
  color: 'black',
  fontFamily: 'Fjalla one',
  fontSize: '20px',
  lineHeight: '25px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 13px',
});

const AuthorLink = styled(Link)({
  display: 'flex',
  flexDirection: 'row',
});

const NoteAuthorSection = (props) => {
  const { isLogin } = useContext(AppContext);
  const { noteData } = props;
  const id = noteData.author._id;
  const currentUserId = useSelector(selectUser);
  const iscurrentUserFollow = noteData.author.followers.includes(currentUserId);
  const notAuthor = currentUserId !== id ? true : false;
  const linkUrl = `/user/${id}`;
  const [open, setOpen] = useState(false);
  const [followNoteAuthor] = useFollowUserMutation();
  const [unfollowNoteAuthor] = useUnfollowUserMutation();

  const handleFollowBtnClick = async () => {
    if (iscurrentUserFollow) {
      setOpen(true);
    } else {
      await followNoteAuthor({ id, userId: currentUserId });
      setOpen(false);
      toastFollow(noteData.author.userName);
    }
  };

  const unfollowTheUser = async () => {
    await unfollowNoteAuthor({ id, userId: currentUserId });
    setOpen(false);
    toastUnfollow(noteData.author.userName);
  };

  const closeThePopUpWindow = () => {
    setOpen(false);
  };

  return (
    <AuthorContainer>
      <AuthorLink href={linkUrl} underline="none">
        <AvatarBox src={noteData.author.avatar || DEFAULT_AVATAR} />
        <AuthorName>{noteData.author.userName}</AuthorName>
      </AuthorLink>
      {notAuthor && currentUserId && isLogin ? (
        <UserFollowBtn
          followState={iscurrentUserFollow}
          handleClick={handleFollowBtnClick}
          currentUser={currentUserId}
        />
      ) : null}
      <PopupNotification />
      <ActionDialog
        img={noteData.author.avatar || DEFAULT_AVATAR}
        name={noteData.author.userName}
        onClose={closeThePopUpWindow}
        open={open}
        variant="user"
        action="unfollow"
        actionHandler={unfollowTheUser}
        cancelHandler={closeThePopUpWindow}
      />
    </AuthorContainer>
  );
};

export default NoteAuthorSection;
